<div
  #applePay
  class="apple-pay-button apple-pay-button-black"
  (click)="onApplePayClick()"
></div>
